export default __webpack_public_path__ + "static/media/github.696c2d9d.jpg";